import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=6d7a467d&"
var script = {}
import style0 from "./Tag.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports